import { Fragment } from 'react';

import { CenteredSpinner } from '../CenteredSpinner/CenteredSpinner';
import { Input } from '../Form/Input/Input';
import { ImageUploadInput } from '../Form/ImageUploadInput/ImageUploadInput';
import { SubmitButton } from '../Form/SubmitButton/SubmitButton';
import { Form } from '../Form/Form';

import { FlightTimes } from './FlightTimes/FlightTimes';

import type { SvpAsset } from '../../types';

type Props = {
  asset: SvpAsset;
  onSubmit: (values: SvpAsset) => Promise<void>;
  isLoading?: boolean;
};

function AssetForm({ asset, onSubmit, isLoading = false }: Props) {
  const isLiveAsset = asset.streamType === 'live';

  return (
    <Form initialValues={asset} onSubmit={onSubmit}>
      {isLoading ? (
        <CenteredSpinner />
      ) : (
        <Fragment>
          <Input
            name="title"
            label="Asset title"
            disabled
            value={asset.title}
          />
          {isLiveAsset && <FlightTimes />}
          <ImageUploadInput
            name="additional.metadata.verticalPosterImage"
            label="Vertical poster image"
            aspectRatio={2 / 3}
          />
        </Fragment>
      )}
      <SubmitButton>Save</SubmitButton>
    </Form>
  );
}

export { AssetForm };
